import starRatingTemplate from './../templates/starRating';
import fecha from 'fecha';

// Verivox's own ratings endpoint
// (servicehook/ugc/power/providers/<id>/ratings/) answers 500 with an NHibernate
// error, reproducible with plain curl and nothing of ours involved, so the review
// list cannot load. The "Bewertungen anzeigen" link is therefore suppressed.
// The star ratings above it are unaffected: they come from the tariff payload,
// not from that endpoint. Set this back to true once Verivox serves it again.
const SHOW_RATING_DETAILS_LINK = false;

export default class VerivoxTabs
{
    constructor() {

    }

    prepareConditionsTab(conditionArr) {
        let dataArr = [];

        $.each(conditionArr, (key, value) => {

            if (key === 'termsAndConditions' && value.content.text !== undefined) {
                // Trennlinie
                dataArr = this.pushToArrWithClass('small-12', '<div class="divider"></div>', dataArr);
                // Beschreibung der Tarifkonditionen
                dataArr = this.pushToArrWithClass('small-12', value.content.text, dataArr);
            } else {
                if (value.caption !== undefined ) {
                    if (value.caption.text !== undefined &&  value.content.text !== undefined) {
                        dataArr = this.pushToArrWithClass('small-6 silent-caption', value.caption.text, dataArr);
                        dataArr = this.pushToArrWithClass('small-6', value.content.text, dataArr);
                    }
                }
            }
        });

        return this.buildRowColumnConstruct(dataArr);
    }

    prepareEnergyTab(data) {
        let dataArr = [];
        let energyArr = data.energySources;

        // Only electricity tariffs carry energySources, and only strom.html.twig
        // renders an energy tab. Without this the whole ajax callback died here
        // for gas, so the provider tab after it never got filled either.
        if (!energyArr || !energyArr.sources || !energyArr.sources.list) {
            return '';
        }

        let chartHTML = `<canvas id="chart-${data.tariff['@attributes'].id}" height="300" width="300">`;

        if ('0' in energyArr.sources.list.source) {
            energyArr.sources.list.source.forEach(value => {
                chartHTML += `<div data-value="${value['@attributes'].percent}" data-color="${this.getEnergyColor(value.caption.text)}">${value.caption.text}</div>`;
                dataArr = this.pushToArrWithClass('small-6 silent-caption', value.caption.text, dataArr);
                dataArr = this.pushToArrWithClass('small-6', value.content.text, dataArr);
            });
        } else {
            chartHTML += `<div data-value="${energyArr.sources.list.source['@attributes'].percent}" data-color="${this.getEnergyColor(energyArr.sources.list.source.caption.text)}">${energyArr.sources.list.source.caption.text}</div>`;
            dataArr = this.pushToArrWithClass('small-6 silent-caption', energyArr.sources.list.source.caption.text, dataArr);
            dataArr = this.pushToArrWithClass('small-6', energyArr.sources.list.source.content.text, dataArr);
        }

        chartHTML += '</canvas>';

        dataArr = this.pushToArrWithClass('small-12 text-center', chartHTML, dataArr);

        return this.buildRowColumnConstruct(dataArr);
    }

    getEnergyColor(energySource) {
        switch(energySource) {
            case 'Nuklear':
                return '#ffca0e';
            case 'Regenerativ':
                return '#2bbb00';
            case 'Regenerativ (EEG gefördert)':
                return '#107b35';
            case 'sonstige fossile Energieträger':
                return '#9d9d9d';
            case 'Kohle':
                return '#4b4b4b';
            case 'Erdgas':
                return '#4f83dc';
            default:
                return '#0BD789';
        }
    }

    preparePriceTab(data) {
        let costArr = data.tariff.cost;
        let date = data.tariff.validity['@attributes'].from.split('T');
        let dataArr = [];

        date = fecha.parse(`${date[0]} ${date[1]}`, 'YYYY-MM-DD HH:mm:ss');

        let oneTimeCost = costArr.subTotal.costDetails.oneTimeCosts.costDescriptionItems.costDescriptionItem;

        // Verbrauchspreise
        if (oneTimeCost.length > 1) {
            oneTimeCost = oneTimeCost[0];
        }

        dataArr = this.pushToArrWithClass('small-3 silent-caption', oneTimeCost.description, dataArr);
        dataArr = this.pushToArrWithClass('small-3', oneTimeCost.amountFormatted, dataArr);
        dataArr = this.pushToArrWithClass('small-6', oneTimeCost.unitPriceRemark, dataArr);
        // Grundpreis
        dataArr = this.pushToArrWithClass('small-3 silent-caption', costArr.subTotal.costDetails.recurringCosts.costDescriptionItems.costDescriptionItem.description, dataArr);
        dataArr = this.pushToArrWithClass('small-3', '+' + costArr.subTotal.costDetails.recurringCosts.costDescriptionItems.costDescriptionItem.amountFormatted, dataArr);
        dataArr = this.pushToArrWithClass('small-6', costArr.subTotal.costDetails.recurringCosts.costDescriptionItems.costDescriptionItem.unitPriceRemark, dataArr);
        // Trennlinie
        dataArr = this.pushToArrWithClass('small-12', '<div class="divider"></div>', dataArr);
/*
        if ('averageMonthlyCostInfo' in costArr) {
            dataArr = this.pushToArrWithClass('small-3 silent-caption', costArr.averageMonthlyCostInfo.caption.text, dataArr);
            dataArr = this.pushToArrWithClass('small-3', costArr.averageMonthlyCostInfo.comment, dataArr);
            dataArr = this.pushToArrWithClass('small-6', costArr.averageMonthlyCostInfo.content.text, dataArr);
            dataArr = this.pushToArrWithClass('small-12', '<div class="divider"></div>', dataArr);
        }
*/

        // Gesamtpreis ohne Boni
        if ('effectiveCost' in costArr.subTotal) {
            dataArr = this.pushToArrWithClass('small-3 silent-caption', costArr.subTotal.effectiveCost.caption.text, dataArr);
            dataArr = this.pushToArrWithClass('small-3', costArr.subTotal.effectiveCost.content.text, dataArr);
        }


        // Gesamtpreis ohne Boni Erklärung
        dataArr = this.pushToArrWithClass('small-6', '', dataArr);
        // Trennlinie
        dataArr = this.pushToArrWithClass('small-12', '<div class="divider"></div>', dataArr);

        // Sämtliche hinterlegte Boni
        if ('bonus' in costArr.total.costDetails) {
            if ('0' in costArr.total.costDetails.bonus.invoiceItems.invoiceItem) {
                costArr.total.costDetails.bonus.invoiceItems.invoiceItem.forEach(item => {
                    dataArr = this.pushToArrWithClass('small-3 silent-caption', item.caption.text, dataArr);
                    dataArr = this.pushToArrWithClass('small-3', item.content.text, dataArr);
                    dataArr = this.pushToArrWithClass('small-6', item.remarks.remark.content.text, dataArr);
                });
            } else {
                // Falls nur ein Bonus hinterlegt ist
                dataArr = this.pushToArrWithClass('small-3 silent-caption', costArr.total.costDetails.bonus.invoiceItems.invoiceItem.caption.text, dataArr);
                dataArr = this.pushToArrWithClass('small-3', costArr.total.costDetails.bonus.invoiceItems.invoiceItem.content.text, dataArr);
                dataArr = this.pushToArrWithClass('small-6', costArr.total.costDetails.bonus.invoiceItems.invoiceItem.remarks.remark.content.text, dataArr);
            }
        }

        // Trennlinie
        dataArr = this.pushToArrWithClass('small-12', '<div class="divider"></div>', dataArr);
        // Gesamtpreis mit Bonus
        dataArr = this.pushToArrWithClass('small-3 text-bold', costArr.total.effectiveCost.caption.text, dataArr);
        dataArr = this.pushToArrWithClass('small-9 text-bold', costArr.total.effectiveCost.content.text, dataArr);
        // Gültigkeitsdatum
        dataArr = this.pushToArrWithClass('small-3 silent-caption', 'Gültig seit', dataArr);
        dataArr = this.pushToArrWithClass('small-9', fecha.format(date, 'DD.MM.YYYY'), dataArr);

        return this.buildRowColumnConstruct(dataArr);
    }

    prepareProviderTab(data) {
        let providerArr = data.provider;
        let rating = data.userRatings;
        let dataArr = [];

        // Adressenbereich
        let providerAddress = `<div class="provider-address"><span class="text-bold caption">${providerArr.caption.text}</span><strong>${providerArr.content.text}</strong><br>`;
        providerAddress += `${providerArr.street.text}<br>${providerArr.postcode.text} ${providerArr.city.text}</div>`;

        dataArr = this.pushToArrWithClass('large-6 medium-12 m-b-2', providerAddress, dataArr);

        // Bewertungstext
        let ratingIntro = `<div class="rating-info"><span class="text-bold caption">Kundenbewertungen:</span>Verifizierte Kundenbewertungen für ${providerArr.content.text}</div>`;
        dataArr = this.pushToArrWithClass('large-6 medium-12 m-b-2', ratingIntro, dataArr);

        //Unternehmerkennzahlen
        if ('businessProfile' in providerArr && 'remarks' in providerArr.businessProfile) {
            dataArr = this.pushToArrWithClass('large-6 medium-12 provider-information', providerArr.businessProfile.remarks.remark.content.text, dataArr);
        } else {
            dataArr = this.pushToArrWithClass('large-6 medium-12', '&nbsp;', dataArr);
        }

        // Bewertungsbereich: Tatsächliche Werte
        dataArr = this.pushToArrWithClass('large-6 medium-12', this.buildRating(rating), dataArr);

        // Anzeigen der einzelnen Bewertungen || Wenn keien Ratings vorhanden sind, muss der Button nicht generiert werden!
        if (SHOW_RATING_DETAILS_LINK && rating.switchAgain['@attributes'].totalReviews > 0) {
            let ratingButton = `<a href="#" class="get-ratings" data-total="${data.userRatings.switchAgain['@attributes'].totalReviews}" data-provider="${providerArr['@attributes'].id}" data-provider-name="${providerArr.content.text}">Bewertungen anzeigen</a>`;
            dataArr = this.pushToArrWithClass('medium-12 text-left large-6 large-offset-6', ratingButton, dataArr);
        }

        return this.buildRowColumnConstruct(dataArr);
    }

    buildRating(rating) {
        let html = '<div class="ratings row">';
        html += `<div class="star-ratings big column small-12" data-rating="${rating.switchAgain['@attributes'].percent}">`;
        html += this.getRatingTemplate();
        html += `<div class="silent-caption big">${rating.switchAgain['@attributes'].percent}%</div>`;
        html += `<div class="description">${rating.switchAgain['@attributes'].percent}% von ${rating.switchAgain['@attributes'].totalReviews} Kunden würden wieder zu diesem Anbieter wechseln.</div>`;
        html += '</div>';
        html += `<div class="star-ratings column small-12" data-rating="${rating.additonalCustomerRatings.service['@attributes'].percent}">`;
        html += `<div class="silent-caption">${rating.additonalCustomerRatings.service.caption.text}</div>`;
        html += this.getRatingTemplate();
        html += '</div>';
        html += `<div class="star-ratings column small-12" data-rating="${rating.additonalCustomerRatings.price['@attributes'].percent}">`;
        html += `<div class="silent-caption">${rating.additonalCustomerRatings.price.caption.text}</div>`;
        html += this.getRatingTemplate();
        html += '</div>';
        html += `<div class="star-ratings column small-12" data-rating="${rating.additonalCustomerRatings.switching['@attributes'].percent}">`;
        html += `<div class="silent-caption">${rating.additonalCustomerRatings.switching.caption.text}</div>`;
        html += this.getRatingTemplate();
        html += '</div>';
        html += '</div>';

        return html;
    }

    buildRowColumnConstruct(data) {
        let html = '<div class="row">';

        data.forEach(value => {
            if (value.row) {
                html += `<div class="column ${value.class}"><div class="row"><div class="column small-12">${value.data}</div></div></div>`;
            } else {
                html += `<div class="column ${value.class}">${value.data}</div>`;
            }
        });

        html += '</div>';

        return html;
    }

    getRatingTemplate() {
        return starRatingTemplate();
    }

    pushToArrWithClass(colClass, data, dataArr, newRow = false) {
        dataArr.push({
            'class': colClass,
            data: data,
            row: newRow
        });

        return dataArr;
    }
}
